// apps/client/utils/price.ts

/**
 * 税込み金額を計算する（10% 税込）
 */
export function calcTaxIncluded(price: number | null | undefined): number {
  const value = Number(price)
  if (isNaN(value)) return 0
  return Math.round(value * 1.1)
}

